export * from './api';
export * from './ui';

export enum ProductionOrderStatus {
  DRAFT = 'DRAFT',
  TO_EXPORT = 'TO_EXPORT',
  EXPORTED = 'EXPORTED',
  CREATED = 'CREATED',
  RELEASED = 'RELEASED',
  CLOSED = 'CLOSED',
  TO_UPDATE = 'TO_UPDATE',
  TECO = 'TECO',
  CANCELLED = 'CANCELLED',
  TO_CANCEL = 'TO_CANCEL',
  /**
   * The Production Order's status failed to sync with SAP, so the real status
   * is unknown. Every allocation and PO input is blocked until the sync is
   * repaired, except the allocation's planned dates, which carry their own
   * column on the allocation editability tables.
   */
  DIVERGENT = 'DIVERGENT'
}

export enum AllocationStatus {
  ALLOCATED = 'ALLOCATED',
  EMPTY = 'EMPTY',
  LOCKED = 'LOCKED',
  PUBLISHED = 'PUBLISHED',
  PO_CANCELLED = 'PO_CANCELLED',
  CLOSED = 'CLOSED',
  /**
   * Soft-deleted allocation still linked to a Production Order in `CREATED` or
   * `RELEASED`. Terminal and fully read-only: no edition, no action, and the
   * discard moment is exposed through `updated_at` + `property_timezone`.
   */
  DISCARDED = 'DISCARDED'
}

export type StringToNumber<T> = {
  [K in keyof T]: T[K] extends string
    ? number
    : T[K] extends object
      ? StringToNumber<T[K]>
      : T[K];
};
